/**
 * Проверка контрольного числа СНИЛС и его форматирование
 * в вид `999-999-999 99` (ТЗ п. 5.2.1, FR-07, FR-08).
 */

export function normalizeSnils(value: string): string {
  return (value ?? '').replace(/\D/g, '');
}

export function formatSnils(value: string): string {
  const d = normalizeSnils(value);
  if (d.length !== 11) return value ?? '';
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6, 9)} ${d.slice(9)}`;
}

export function isValidSnils(value: string): boolean {
  const d = normalizeSnils(value);
  if (d.length !== 11) return false;

  // Номера до 001-001-998 контрольного числа не имеют.
  const numberPart = d.slice(0, 9);
  if (Number(numberPart) <= 1001998) return true;

  let sum = 0;
  for (let i = 0; i < 9; i++) sum += Number(numberPart[i]) * (9 - i);

  let control = sum;
  if (sum > 101) control = sum % 101;
  if (control === 100 || control === 101) control = 0;

  return control === Number(d.slice(9));
}

export function snilsError(value: string): string | null {
  const d = normalizeSnils(value);
  if (!d) return 'СНИЛС не указан';
  if (d.length !== 11) return 'СНИЛС содержит 11 цифр';
  if (!isValidSnils(d)) return 'Неверное контрольное число СНИЛС';
  return null;
}
